import React from 'react';
import { ActivityIndicator, View, StyleSheet, TouchableOpacity, Text, Platform } from 'react-native';
import { translate } from 'react-i18next';
import { trackingTileSelected } from '../actions';
import { connect } from 'react-redux';
import TrackingLoadingError from './tracking-loading-error';
import { ButtonSize, Icon } from '../../components';
import Theme from '../../theme';
import WorkoutTopImage from '../../assets/images/trackinghr.jpg';
import { TrackingImageTile } from './TrackingImageTile';
import { StartWorkoutButton } from '../../SummaryDashboard/components/StartWorkoutButton';
import { WeeklyWorkoutBarGraph } from './WeeklyWorkoutBarGraph';
import { EffortPointGraph } from './EffortPointGraph';
import { LastWorkoutTile } from './LastWorkoutTile';
import { TileHeader } from './TileHeader';
import { defaultScale, graphScaleLine, fullScale, scaleImageAspectRatio } from '../../utils/scaling';
import { BookOrJoinWorkoutButton } from '../../Bookings/components/BookOrJoinWorkoutButton';

const isAllWeb = Platform.OS === 'web';

class TrackingWorkoutTile extends React.PureComponent {
  render() {
    const { t, isLoading, loadingError, userProfile, weeklyWorkoutProgress,
      hasStartedAtLeastOneWOrkout, navigation } = this.props;
    let isError = this.props.workoutStats && this.props.workoutStats.find((stat) => stat.error !== undefined);
    const { targetData, graphData, graphDateLabels, currentWeekIndex } = weeklyWorkoutProgress || {};

    if (isError && isError.error === 'Heart rate monitor setup is required') {
      isError.error = t('hrMonitorSetupErrorMessage');
    }
    if (this.props.totals && this.props.totals.total > 0) {
      isError = null;
    }
    if (isLoading) {
      return (
        <ActivityIndicator
          size='large'
          animating
          color={Theme.PRIMARY}
          style={styles.loader}
        />
      );
    }
    if (loadingError) {
      return <TrackingLoadingError containerStyle={styles.noBorder} />;
    }
    return <View>
      {!hasStartedAtLeastOneWOrkout &&
        <TrackingImageTile
          containerStyle={styles.imageStyle}
          imageSource={WorkoutTopImage}
          title={t('trackProgress')}
          useGradient
          titleStyle={{
            paddingRight: defaultScale(100),
            paddingBottom: defaultScale(20),
          }}
          actions={
            <BookOrJoinWorkoutButton
              workoutSessions={this.props.workoutSessions}
              userProfile={userProfile}
              workoutSessionService={this.props.workoutSessionService}
              t={t}
              navigation={navigation}
            />
          } />
      }
      <TouchableOpacity style={styles.tileContainer}
        onPress={() => { navigation.navigate('TrackingWorkoutStats'); }}
      >
        <TileHeader>{t('tracking:weeklyWorkouts')}</TileHeader>
        <View style={styles.graphLegendContainer}>
          <View style={{ flexDirection: 'row' }}>
            <View style={[styles.legendIcon, { backgroundColor: Theme.PRIMARY }]}></View>
            <Text style={styles.legendText}>Completed Mins</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <View style={[styles.legendIcon, { backgroundColor: 'rgba(0, 0, 0, 0.2)' }]}></View>
            <Text style={styles.legendText}>Target Mins</Text></View>
        </View>
        <WeeklyWorkoutBarGraph
          graphData={graphData}
          targetData={targetData}
          labels={graphDateLabels}
          currentWeekIndex={currentWeekIndex}
        />
      </TouchableOpacity>
      {/* todo: we hid this, since we don't want emphasis on the workouts tab to check your last workouts
         this might be used when we implement the new feed
      <LastWorkoutTile userProfile={userProfile} navigation={navigation} />
      */}
      <EffortPointGraph userProfile={userProfile} navigation={navigation} />
    </View>;
  }
}

const styles = StyleSheet.create({
  imageStyle: {
    width: '100%',
    ...Platform.select({
      web: {
        height: '40vh',
      },
      default: {
        aspectRatio: scaleImageAspectRatio(1.55),
      },
    }),
  },
  tileContainer: {
    backgroundColor: Theme.WHITE,
    marginVertical: defaultScale(12),
    paddingHorizontal: fullScale(16),
    paddingTop: defaultScale(20),
    paddingBottom: fullScale(16),
  },
  scanButtonContainer: {
    marginVertical: defaultScale(5),
  },
  loader: {
    height: defaultScale(300),
    justifyContent: 'center',
    alignItems: 'center',
  },
  noBorder: {
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  weeklyWorkoutsHeading: {
    marginBottom: defaultScale(11),
    ...Theme.textStyle.heading,
    color: Theme.BLACK,
  },
  graphLegendContainer: {
    flexDirection: 'row',
    marginBottom: defaultScale(15),
    marginTop: defaultScale(20),
    paddingLeft: defaultScale(3),
  },
  legendText: {
    ...Theme.graphStyle.regular12,
    color: Theme.BLACK,
    marginRight: defaultScale(13),
  },
  legendIcon: {
    width: graphScaleLine(8),
    height: graphScaleLine(8),
    marginRight: defaultScale(12),
    alignSelf: 'center',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    trackingTileSelected: (tileName) => dispatch(trackingTileSelected(tileName)),
  };
};

const mapStateToProps = (state) => {
  const { totalStartedWorkouts } = state.summaryDashboard.data;
  return {
    hasStartedAtLeastOneWOrkout: totalStartedWorkouts > 0,
    workoutSessions: state.planner.workoutSessions,
  };
};

TrackingWorkoutTile = connect(mapStateToProps, mapDispatchToProps)(TrackingWorkoutTile);

export default translate(['workoutHistory'], { wait: true })(TrackingWorkoutTile);
